// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Modal_Wrapper__2HZ3a","Container":"Modal_Container__37bDZ","Form":"Modal_Form__T6_VS"};